import axios from "axios";
import { API_URL } from "../../constants";

/** Load a board with its columns + cards (cards already carry badge counts). */
export const fetchBoard = async (
  companyId: string,
  boardId: string,
  filtersValue?: unknown
) => {
  const url = `${API_URL}/${companyId}/project-boards/${boardId}`;
  return axios.get(url, { params: filtersValue }).then((res) => res.data);
};

/** Persist a card move. Body: { projectBoardColumn, order }. */
export const moveProjectApi = async (
  companyId: string,
  cardId: string,
  body: { projectBoardColumn: string; order: number | null }
) => {
  const url = `${API_URL}/${companyId}/projects/${cardId}/move`;
  return axios.patch(url, body).then((res) => res.data);
};

/** Persist a column move. Body: { order }. */
export const moveColumnApi = async (
  companyId: string,
  columnId: string,
  body: { order: number | null }
) => {
  const url = `${API_URL}/${companyId}/project-board-columns/${columnId}/move`;
  return axios.patch(url, body).then((res) => res.data);
};

/** Quick-add a card to a column. */
export const createCardApi = async (companyId: string, body: unknown) => {
  const url = `${API_URL}/${companyId}/projects`;
  return axios.post(url, body).then((res) => res.data);
};

/** Quick-add a list/column to the board. */
export const createColumnApi = async (companyId: string, body: unknown) => {
  const url = `${API_URL}/${companyId}/project-board-columns`;
  return axios.post(url, body).then((res) => res.data);
};

/** Mark a card as seen by the current user (sticky). */
export const markCardSeenApi = async (companyId: string, cardId: string) => {
  const url = `${API_URL}/${companyId}/projects/${cardId}/seen`;
  return axios.post(url).then((res) => res.data);
};
